import { render, staticRenderFns } from "./SelectboxControl.vue?vue&type=template&id=34b4883e"
import script from "./SelectboxControl.vue?vue&type=script&lang=ts"
export * from "./SelectboxControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports